import React from 'react';
import PropTypes from 'prop-types';

export const Icon = ({
  icon,
  ...props
}) => {
  return (
    <i className={`Icon Icon-${icon}`} {...props} />
  )
};

Icon.propTypes = {
  icon: PropTypes.oneOf([
    'tiktok',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-up',
    'at-sign',
    'award',
    'bell',
    'bell-off',
    'bookmark',
    'calendar',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'credit-card',
    'edit',
    'filter',
    'hash',
    'heart',
    'help-circle',
    'home',
    'image',
    'link',
    'map-pin',
    'menu',
    'message-circle',
    'message-square',
    'mic',
    'mic-off',
    'music',
    'paperclip',
    'pause',
    'phone',
    'play',
    'plus',
    'radio',
    'rss',
    'save',
    'search',
    'send',
    'share',
    'shopping-cart',
    'skip-back',
    'skip-forward',
    'slash',
    'star',
    'thumbs-down',
    'thumbs-up',
    'trash',
    'video',
    'volume',
    'volume-1',
    'volume-2',
    'volume-x',
    'wifi',
    'cross',
    'youtube',
    'zoom-in',
    'zoom-out',
    'facebook',
    'instagram',
    'twitter'
  ]).isRequired
};
